<% if ( placeholders.length > 0 ) { %>

<% placeholders.forEach(( p ) => { %>
<div class="mb-4">
    <!-- Header with key and type badge -->
    <div class="d-flex align-items-center mb-2">
        <label class="form-label text-muted text-uppercase fw-bold detail-label mb-0" for="placeholder-<%= p.key %>">
            <%= p.key %>
        </label>
        <span class="badge bg-secondary ms-2"><%= getTypeLabel( p.type ) %></span>
    </div>

    <% if ( p.type === 'string' ) { %>
    <!-- String input -->
    <input type="text"
           class="form-control"
           id="placeholder-<%= p.key %>"
           name="<%= p.key %>"
           placeholder="<%= p.description || 'Enter text...' %>" />

    <% } else if ( p.type === 'number' ) { %>
    <!-- Number input -->
    <input type="number"
           class="form-control"
           id="placeholder-<%= p.key %>"
           name="<%= p.key %>"
           step="any"
           placeholder="<%= p.description || 'Enter number...' %>" />

    <% } else if ( p.type === 'date' ) { %>
    <!-- Date input -->
    <input type="datetime-local"
           class="form-control"
           id="placeholder-<%= p.key %>"
           name="<%= p.key %>" />

    <% } else if ( p.type === 'boolean' ) { %>
    <!-- Boolean checkbox -->
    <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input"
               id="placeholder-<%= p.key %>"
               name="<%= p.key %>"
               role="switch" />
        <label class="form-check-label" for="placeholder-<%= p.key %>">
            <%= p.description || 'Enable' %>
        </label>
    </div>
    <% if ( p.condition ) { %>
    <div class="form-text text-info">
        <i class="ti ti-info-circle me-1"></i>Condition: <code><%= p.condition %></code>
    </div>
    <% } %>

    <% } else if ( p.type === 'image' ) { %>
    <!-- Image upload -->
    <input type="file"
           class="form-control"
           id="placeholder-<%= p.key %>"
           name="<%= p.key %>"
           data-type="image"
           accept="image/*" />
    <img id="preview-<%= p.key %>"
         class="mt-2 img-thumbnail"
         style="display: none; max-width: 200px; max-height: 150px;"
         alt="Preview" />

    <% } else if ( p.type === 'array' ) { %>
    <!-- Array items -->
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center py-2">
            <span class="text-muted small">
                <i class="ti ti-list me-1"></i>
                <%= arrayCounters[ p.key ] || 1 %> item(s)
            </span>
            <div class="btn-group btn-group-sm">
                <button type="button"
                        class="btn btn-outline-danger"
                        data-action="remove-array-item"
                        data-array-key="<%= p.key %>"
                        <%= ( arrayCounters[ p.key ] || 1 ) <= 1 ? 'disabled' : '' %>>
                    <i class="ti ti-minus"></i>
                </button>
                <button type="button"
                        class="btn btn-outline-success"
                        data-action="add-array-item"
                        data-array-key="<%= p.key %>">
                    <i class="ti ti-plus"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <% if ( p.loopItems && p.loopItems.length > 0 ) { %>
                <% const itemCount = arrayCounters[ p.key ] || 1; %>
                <% for ( let idx = 0; idx < itemCount; idx++ ) { %>
                <div class="array-item <%= idx > 0 ? 'mt-3 pt-3 border-top' : '' %>">
                    <div class="d-flex align-items-center mb-2">
                        <span class="badge bg-primary me-2">#<%= idx + 1 %></span>
                        <span class="text-muted small">Item <%= idx + 1 %></span>
                    </div>
                    <div class="row g-2">
                        <% p.loopItems.forEach(( item ) => { %>
                        <div class="col-md-6">
                            <label class="form-label small text-muted" for="<%= p.key %>-<%= idx %>-<%= item.key %>">
                                <%= item.key %>
                                <span class="badge bg-light text-dark"><%= getTypeLabel( item.type ) %></span>
                            </label>

                            <% if ( item.type === 'boolean' ) { %>
                            <div class="form-check form-switch">
                                <input type="checkbox"
                                       class="form-check-input"
                                       id="<%= p.key %>-<%= idx %>-<%= item.key %>"
                                       name="<%= p.key %>[<%= idx %>].<%= item.key %>"
                                       role="switch" />
                            </div>

                            <% } else if ( item.type === 'number' ) { %>
                            <input type="number"
                                   class="form-control form-control-sm"
                                   id="<%= p.key %>-<%= idx %>-<%= item.key %>"
                                   name="<%= p.key %>[<%= idx %>].<%= item.key %>"
                                   step="any"
                                   placeholder="<%= item.key %>" />

                            <% } else if ( item.type === 'date' ) { %>
                            <input type="datetime-local"
                                   class="form-control form-control-sm"
                                   id="<%= p.key %>-<%= idx %>-<%= item.key %>"
                                   name="<%= p.key %>[<%= idx %>].<%= item.key %>" />

                            <% } else { %>
                            <input type="text"
                                   class="form-control form-control-sm"
                                   id="<%= p.key %>-<%= idx %>-<%= item.key %>"
                                   name="<%= p.key %>[<%= idx %>].<%= item.key %>"
                                   placeholder="<%= item.key %>" />
                            <% } %>
                        </div>
                        <% }); %>
                    </div>
                </div>
                <% } %>
            <% } else { %>
            <div class="text-muted small">
                <i class="ti ti-alert-circle me-1"></i>
                No item properties detected. Add properties inside the loop in your template.
            </div>
            <% } %>
        </div>
    </div>

    <% } else { %>
    <!-- Fallback: text input -->
    <input type="text"
           class="form-control"
           id="placeholder-<%= p.key %>"
           name="<%= p.key %>"
           placeholder="<%= p.description || '' %>" />
    <% } %>

    <!-- Description and options hint -->
    <% const optionsHint = getOptionsHint( p ); %>
    <% if ( p.description || optionsHint ) { %>
    <div class="form-text">
        <% if ( p.description ) { %><%= p.description %><% } %>
        <% if ( p.description && optionsHint ) { %> &mdash; <% } %>
        <% if ( optionsHint ) { %><span class="text-info"><%= optionsHint %></span><% } %>
    </div>
    <% } %>
</div>
<% }); %>

<% } else { %>
<div class="text-center py-4">
    <div class="mb-3">
        <i class="ti ti-file-off" style="font-size: 3rem; opacity: 0.3;"></i>
    </div>
    <p class="text-muted mb-0">This template has no placeholders.</p>
    <p class="text-muted small">Upload a template file with placeholders to test document generation.</p>
</div>
<% } %>

<hr class="my-4" />

<div class="d-flex justify-content-between align-items-center">
    <div class="text-muted small">
        <i class="ti ti-info-circle me-1"></i>
        Fill in the values above and click "Run Test Generation" to generate a document.
    </div>

    <div class="d-flex gap-2">
        <button type="button" data-type="test-center-show-code" class="btn btn-outline-secondary">
            <i class="ti ti-code me-2"></i>Example Code
        </button>
        <button type="button" data-type="test-center-run-html" class="btn btn-outline-primary" <%= placeholders.length === 0 ? 'disabled' : '' %>>
            <i class="ti ti-file-text me-2"></i>Run HTML Generation
        </button>
        <button type="button" data-type="test-center-run" class="btn btn-primary" <%= placeholders.length === 0 ? 'disabled' : '' %>>
            <i class="ti ti-player-play me-2"></i>Run Test Generation
        </button>
    </div>
</div>
